import { render } from "./IconCamera.vue?vue&type=template&id=6c7dc92e"
import script from "./IconCamera.vue?vue&type=script&lang=js"
export * from "./IconCamera.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__